import i18n from "i18next";
import { Resource } from "i18next";
// import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next";

import translationEnGB from "./locales/en/en-GB.json";
import translationNlNL from "./locales/nl/nl-NL.json";

const resources: Resource = {
	en: { translation: translationEnGB },
	nl: { translation: translationNlNL },
};

//const lang = localStorage.swapLanguage || "en";

i18n.use(initReactI18next).init({
	resources,
	fallbackLng: "en", //lang,
	debug: false,
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
